import { useState, useCallback, useMemo } from "react";
import toast from "react-hot-toast";

export const useEntityStatus = ({
  entities,
  refreshFn,
  toggleFn,
  entityName,
}) => {
  const [statusFilter, setStatusFilter] = useState("active");
  const [modalEntity, setModalEntity] = useState(null);
  const [pendingIsActive, setPendingIsActive] = useState(false);
  const [togglingId, setTogglingId] = useState(null);

  const filteredEntities = useMemo(() => {
    if (statusFilter === "all") return entities;
    return entities.filter((e) =>
      statusFilter === "active" ? e.isActive : !e.isActive,
    );
  }, [entities, statusFilter]);

  const requestToggle = useCallback((entity) => {
    setModalEntity(entity);
    setPendingIsActive(!entity.isActive);
  }, []);

  const confirmToggle = useCallback(async () => {
    if (!modalEntity) return;
    try {
      setTogglingId(modalEntity._id);
      await toggleFn(modalEntity._id, pendingIsActive);
      toast.success(
        `${entityName} uğurla ${pendingIsActive ? "aktivləşdirildi" : "passivləşdirildi"}`,
      );
      setModalEntity(null);
      await refreshFn();
    } catch (error) {
      toast.error(error.response?.data?.message || "Əməliyyat uğursuz oldu");
      setModalEntity(null);
    } finally {
      setTogglingId(null);
    }
  }, [modalEntity, pendingIsActive, toggleFn, refreshFn, entityName]);

  const closeModal = useCallback(() => {
    setModalEntity(null);
  }, []);

  return {
    statusFilter,
    setStatusFilter,
    filteredEntities,
    requestToggle,
    confirmToggle,
    closeModal,
    modalEntity,
    pendingIsActive,
    togglingId,
  };
};
